<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title" style="font-weight:bold;">Détails de la livraisons</h4>
            </template>

            <div class="uk-container">
            <div class="main-body">
                  <div class="row gutters-sm">
                    <div class="col-md-4 mb-3">
                      <div class="uk-box-shadow-medium mb-4">
                        <div class="card-body">
                          <div class="d-flex flex-column align-items-center text-center">
                            <div class="mt-3">
                               
                            </div>
                            <img src="/img/livreur.jpg" alt="Admin" class="rounded-circle" width="150">
                            <div class="mt-3">
                              <h4 style="color:black; font-weight:bold;">{{Colis.livreur_name}}</h4>
                            </div>
                          </div>
                          
                           <div class="mt-3">
                              <p>
                                <span class="title-detail">
                                  Frais de livraison
                                </span> <br>
                                <span>{{Colis.montant}} FCFA</span>
                              </p>
                          </div>
                          <div class="mt-3">
                              <p>
                                <span class="title-detail">
                                  Valeur du colis 
                                </span> <br>
                                <span>{{Colis.valeur}} FCFA</span>
                              </p>
                          </div>
                          <div class="mt-3">
                              <strong>
                                <p>
                                  <span class="title-detail">
                                    Mode de payement
                                  </span> <br>
                                  <span>{{Colis.payment_method}}</span>
                                </p>
                              </strong>
                          </div>
                          <div class="mt-3" >
                              <strong>
                                <p>
                                  <span class="title-detail">
                                    Contact de récupération
                                  </span> <br>
                                  <span v-if="Colis.colis_type === 'recup_envoi' ">
                                    {{Colis.contact_recup}}
                                  </span>
                                </p>
                                <!-- v-if="Colis.colis_type === 'recup_envoi' " -->
                              </strong>
                          </div>
                          <div class="mt-3">
                              <p>
                                <span class="title-detail">
                                  Date
                                </span> <br>
                                <span style="color:black;">{{Colis.created_at}}</span>
                              </p>
                          </div>
                          <div class="mt-3">
                              <p>
                                <span class="title-detail">
                                  Statut de la livraison
                                </span> <br>
                                <span style="color:black;">{{Colis.statut}}</span>
                              </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="uk-box-shadow-small p-3">
                           <div class="mt-3">
                                <span class="title-detail">
                                  MISE A JOUR
                                </span> <br>
                                <form @submit.prevent="updateColis">
                                   <div class="uk-margin">
                                    <autocomplete :search="search"
                                      placeholder="Choisir un livreur"
                                      aria-label="Choisir un livreur"
                                      :get-result-value="getResultValue"
                                      @submit="selectLivreur"
                                      ></autocomplete>
                                  </div>
                                  <div class="uk-margin">
                                    <label>Choisir le status</label>
                                  <select class="uk-select" v-model="commande.statut">
                                      <option :value="'accepter'">Accepter</option>
                                  </select>
                                  </div>
                                  <button class="uk-button uk-button-primary uk-text-right" >Valider</button>
                                </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="uk-box-shadow-medium mb-4">
                        <div class="card-body">
                          <div class="mt-3">
                            <h3 style="color:black; font-weight:bold">Informations sur la livraison</h3>
                          </div>
                          <br>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">Nom et prenom(s) du client</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                              {{Colis.client_name}}
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">Contact du client</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                              {{Colis.client_phone}}
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">Identifiant du colis</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                              {{this.$route.params.id}}
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">La nature du colis</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                              {{Colis.nature}}
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">Statut du colis</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                              {{Colis.colis_type}}
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">L'adresse de départ du colis</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                             {{Colis.depart_address}}
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">L'adresse de destination du colis</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                             {{Colis.dest_address}}
                            </div>
                          </div>
                          <hr>
                          <div class="row">
                            <div class="col-sm-12">
                              <h6 class="title-detail">Le contact de destination du colis</h6>
                            </div>
                            <div class="col-sm-12" style="color:black; font-size: 1em;">
                              +225 {{Colis.dest_contact}}
                            </div>
                          </div>
                          <hr>
                          
                        </div>
                        <div>
                        <div class="uk-box-shadow-small p-3">
                           <div class="mt-3">
                                <span class="title-detail">
                                  MISE A JOUR DE CONTACT
                                </span> <br>
                                <form @submit.prevent="updateColis">
                                  <div class="uk-margin">
                                    <label>Contact expediteur : </label>
                                     <div>
                                        <div class="uk-inline">
                                          <span class="uk-form-icon" uk-icon="icon: phone"></span>
                                          <input class="uk-input" type="phone" v-model="commande.client_phone" :placeholder="Colis.client_phone">
                                      </div>
                                     </div>
                                  </div>
                                  <div class="uk-margin">
                                    <label> Contact destinataire : </label>
                                        <div>
                                          <div class="uk-inline">
                                            <span class="uk-form-icon" uk-icon="icon: phone" ></span>
                                            <input class="uk-input chic-input" v-model="commande.dest_contact" type="phone" :placeholder="Colis.dest_contact" >
                                        </div>
                                        </div>
                                    </div>
                                  <button class="uk-button uk-button-primary uk-text-right" >Valider</button>
                                </form>
                          </div>
                        </div>
                      </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
            </div>
            
          </card>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../../main";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Voir_livraisons",
  data() {
    return {
      commande: {
        statut: "",
        livreur_id: "",
        livreur_name: "",
        dest_contact:"",
        client_phone:""
      },
      Colis: {},
      Livreur: {},
      livreurs: [],
    };
  },
  methods: {
    search(input) {
      if (input.length < 1) { return [] }
      return this.livreurs.filter(uneboutique => {
        return uneboutique.name.toLowerCase()
          .startsWith(input.toLowerCase())
      })
    },
    getResultValue(result) {
      return result.name
    },
    selectLivreur(result){
      this.commande.livreur_id = result.id
      this.commande.livreur_name = result.name
    },
    updateColis(event){
        if(this.commande.statut){
          db.ref('Colis Requetes').child(this.$route.params.id).child('statut').set(this.commande.statut)
        }
        if(this.commande.livreur_id) {
          db.ref('Colis Requetes').child(this.$route.params.id).child('livreur_id').set(this.commande.livreur_id)
        }
        if(this.commande.livreur_name) {
          db.ref('Colis Requetes').child(this.$route.params.id).child('livreur_name').set(this.commande.livreur_name)
        }
        if (this.commande.dest_contact) {
          db.ref('Colis Requetes').child(this.$route.params.id).child('dest_contact').set(this.commande.dest_contact)
        }
        if (this.commande.client_phone) {
          db.ref('Colis Requetes').child(this.$route.params.id).child('client_phone').set(this.commande.client_phone)
        }
        
      event.preventDefault();
      this.$router.push({ path: "/admin/livraison/encours" });
      Swal.fire({
            position: "center",
            icon: "success",
            title: "mise à jour avec succès",
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
          });
      
    },
  },

  created() {
    let dbRef = db.ref("Colis Requetes").child(this.$route.params.id);
    dbRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Colis = childData;
        let dbRef = db
          .ref("users")
          .child(this.Colis.livreur_id)
          .child(this.Colis.livreur_name)
          .get()
          .then((childSnapshot) => {
            const livreurData = childSnapshot.val();
            this.Livreur = livreurData;
          });
      })
      .catch((error) => {
        console.log(error);
      });
    db.ref("users")
      .orderByChild("role")
      .equalTo("1")
      .once("value")
      .then((dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            role: childData.role,
            statusLivreur: childData.statusLivreur,
            name: childData.name,
            number: childData.number,
            email: childData.email,
          });
        });
        this.livreurs = itemsArray;
      });
  },
};
</script>

<style>
.title-detail{
  color:#32be8f !important;
   font-weight:bold !important; 
   font-size:1.1rem !important; 
   font-family: 'Poppins', 
   sans-serif !important;
}
.btn-primary {
  margin-right: 12px;
}

body {
  color: #1a202c;
  text-align: left;
  background-color: #e2e8f0;
}
.main-body {
  padding: 15px;
}
.card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.gutters-sm {
  margin-right: -8px;
  margin-left: -8px;
}

.gutters-sm > .col,
.gutters-sm > [class*="col-"] {
  padding-right: 8px;
  padding-left: 8px;
}
.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.bg-gray-300 {
  background-color: #e2e8f0;
}
.h-100 {
  height: 100% !important;
}
.shadow-none {
  box-shadow: none !important;
}

</style>

